import React, { useState } from 'react';
import AdminLayout from '../../components/layout/AdminLayout';
import AdminDashboard from './sections/Dashboard';
import AdminUsers from './sections/Users';
import AdminSuggestions from './sections/Suggestions';
import AdminNotices from './sections/Notices';
import AdminSubjects from './sections/Subjects';
import AdminQuestions from './sections/Questions';
import AdminRestBox from './sections/RestBox';
import AdminGeneral from './sections/General';
import AdminAccount from './sections/Account';
import AdminMainMenu from './sections/MainMenu';
import AdminImageEditor from './sections/ImageEditor';
import ContentMonitor from './sections/ContentMonitor';
import CategoryManager from './sections/CategoryManager';  // ✅ 추가
import AdminTypeStats from './sections/TypeStats';  // ✅ 유형 통계

const AdminPage: React.FC = () => {
  const [activeMenu, setActiveMenu] = useState('dashboard');

  const renderContent = () => {
    switch (activeMenu) {
      case 'dashboard': return <AdminDashboard />;
      case 'general': return <AdminGeneral />;
      case 'login-mode': return <AdminGeneral section="login" />;
      case 'main-menu': return <AdminMainMenu />;
      case 'subjects': return <AdminSubjects />;
      case 'questions': return <AdminQuestions />;
      case 'image-editor': return <AdminImageEditor />;
      case 'rest-box': return <AdminRestBox />;
      case 'notices': return <AdminNotices />;
      case 'users': return <AdminUsers />;
      case 'suggestions': return <AdminSuggestions />;
      case 'study': return <AdminGeneral section="study" />;
      case 'account': return <AdminAccount />;
      case 'content-monitor': return <ContentMonitor />;
      case 'category-manager': return <CategoryManager />;  // ✅ 추가
      case 'type-stats': return <AdminTypeStats />;  // ✅ 유형 통계
      default: return <AdminDashboard />;
    }
  };

  return (
    <AdminLayout activeMenu={activeMenu} onMenuChange={setActiveMenu}>
      {renderContent()}
    </AdminLayout>
  );
};

export default AdminPage;
